





















import { defineComponent } from '@nuxtjs/composition-api';
import AppLayoutDefault from '~/components/partials/App/AppLayoutDefault.vue';
import { useLayoutPropsProvider } from '~/composables/internals/useLayoutPropsProvider';

export default defineComponent({
  components: {
    AppLayoutDefault,
  },
  setup() {
    const layoutProps = useLayoutPropsProvider();

    return { layoutProps };
  },
  head: {},
});
